var coreFunctions = function () {
    let throttleTimer = false;

    // Function for XmlHTTPrequests
    function xhrHelper(method, url, success, error, input, options, form) {
        var xhr = new XMLHttpRequest();
		let action = getRequestAction(url);
        console.log(method.toUpperCase(), action);

        if (options) {
            for (var field in options) {
                xhr[field] = options[field];
            }
        }

        updateFormState(form, true);

        // Request finished
        xhr.addEventListener("load", function (event) {
            let response;
			console.log("LOAD", action);
            updateFormState(form, false);

            if (xhr.readyState == 4 && xhr.status == 200) {
                if (xhr.responseType == "json") {
                    response = xhr.response;
                } else {
                    response = xhr.responseText;
                }
                success(response);
            } else {
                error();
            }
        });

        // Define what happens in case of error
        xhr.addEventListener("error", function (event) {
			console.log("ERROR", action);
            updateFormState(form, false);
            error();
        });

        // Error timeout
        xhr.addEventListener("timeout", function (event) {
			console.log("TIMEOUT", action);
            updateFormState(form, false);
            error();
        });

        // Set up request
        xhr.open(method, url);

        // Send input data
        xhr.send(input);

    }

	function getRequestAction(url) {
        let action;
        if (url.includes("action=")) {
            action = url.split("action=")[1].replace(/&.*/, "");
        } else {
            action = url;
        }
        return action;
    }

    // Update state of form by updating disabled state of submit
    function updateFormState(form, disabled) {
        let submitButton;
        if (form && (submitButton = form.querySelector("input[type='submit'], button[type='submit']"))) {
            submitButton.disabled = disabled;
        }
    }

    function getRequestAction(url) {
        let action;
        if (url.includes("action=")) {
            action = url.split("action=")[1].replace(/&.*/, "");
        } else {
            action = url;
        }
        return action;
    }

    // Helper function for creating DOM elements
    function createElementHelper(ele, attrs, events) {
        //create the element with a specified string:
        var element = document.createElement(ele);
        element.add
        //create a for...in loop set attributes:
        for (let val in attrs) {
            //for support in the setAttrubute() method:
            if (element.setAttribute) {
                if (val == "innerHTML" || val == "checked" || val == "indeterminate") {
                    element[val] = attrs[val];
                } else {
                    element.setAttribute(val, attrs[val]);
                }
            } else {
                element[val] = attrs[val];
            }
        }

        // Add events to the element
        for (let action in events) {
            element.addEventListener(action, events[action]);
        }
        //return the element with the set attributes:
        return element;
    }

    function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return (null);
    }

    // Check for any available request debug information
    function checkForDebugMessages(response) {
        try {
            if (response.debug != undefined) {
                for (var field in response.debug) {
                    console.log(response.debug[field]);
                }
            }
        } catch (e) {
            console.log("Could not process debug messages.");
        }
    }

    function showOverlay(category) {
        document.querySelector(`.overlay[category='${category}'], .overlay[data-category='${category}']`).classList.add("overlayVisible");
    }

    function hideOverlay(element) {
        var overlay = element.closest(".overlay");
        overlay.classList.remove("overlayVisible");
    }

    // Show action results / status message
    function showStatusMessage(title, message) {
        messageOverlay.querySelector(".overlayTitle").innerHTML = title;
        messageOverlay.querySelector(".overlayText").innerHTML = message;
        showOverlay("message");
        // Set focus on button
        if (document.querySelector("#messageOverlayButton")) {
            document.querySelector("#messageOverlayButton").focus();
        }
    }

    function getRandomString(length) {
        var characters = '0123456789abcdefghijklmnopqrstuvwxyz';
        var string = '';
        for (var i = 0; i < length; i++) {
            string += characters[Math.floor(Math.random() * Math.floor(characters.length - 1))];
        }

        return string;
    }

    function subscribeRequest() {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        showOverlay("subscribe");
    }

    function capitaliseFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function isValidUrl(url) {
        try {
            new URL(url);
            return true;
        } catch (error) {
            return false;
        }
    }

    function formatUrl(string) {
        if (string == undefined) {
            return null;
        } else if (string.startsWith("http")) {
            return string;
        }  else {
            return `http://${string}`;
        }
    }

    function intersect(a, b) {
        var setA = new Set(a);
        var setB = new Set(b);
        var intersection = new Set([...setA].filter(x => setB.has(x)));
        return Array.from(intersection);
    }

    function signout() {
        var xhr = new XMLHttpRequest();

        xhr.addEventListener("load", function (event) {
            window.location.href = '../';
        });

        // Define what happens in case of error
        xhr.addEventListener("error", function (event) {
            console.log("error signout");
        });

        // Set up our request
        xhr.open("GET", "../api/user/user_actions.php?action=signout");

        // The data sent is what the user provided in the form
        xhr.send();
    }

    function resetPassword(callback, callbackArguments) {
        var xhr = new XMLHttpRequest();
        var FD = new FormData(document.getElementById("resetForm"));

        xhr.addEventListener("load", function (event) {
            var response = JSON.parse(xhr.responseText);
            resetPasswordLoad(response, callback, callbackArguments);
        });

        xhr.addEventListener("error", function (event) {
            var response = {
                "status": "error",
                "input_errors": {
                    "email": "",
                    "password": "",
                    "general": "Could not change password."
                }
            } ;
            resetPasswordLoad(response);
        });

        xhr.open("POST", "../api/user/user_actions.php?action=reset");
        xhr.send(FD);
    }

    function resetPasswordLoad(response, callback, callbackArguments) {
        if (response["input_errors"] != undefined) {
            for (var field in response["input_errors"]) {
                document.querySelector("#resetForm .input_error[field='" + field + "']").innerHTML = response["input_errors"][field];
            }
        }
        if (response.status == "success") {
            hideOverlay(resetForm);
            clearResetFields();
            if (callback) {
                callback(...callbackArguments);
            } else {
                showStatusMessage(response.title, response.message);
            }
        }
    }

    function clearResetFields() {
        document.getElementById("oldPass").value = null;
        document.getElementById("resetPass").value = null;
        document.getElementById("resetPassConfirm").value = null;
    }

    function clearElementContent(element) {
        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }
    }

    function clearElementChildren(element) {
        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }
    }

    function pluraliseWord(singularWord, pluralWord, count) {
        return count == 1 ? singularWord : pluralWord;
    }

    function processFormValidation(form, inputErrors) {
        let inputErrorElements = Array.from(form.querySelectorAll(".inputError[data-field]"));
        inputErrorElements.forEach(element => element.innerHTML = inputErrors[element.dataset.field] ?? "");
    }

    function clearFormValidationError(element) {
        let errorElement;
        if (errorElement = element.closest("form").querySelector(`.inputError[data-field='${element.name}']`)) {
            errorElement.innerHTML = "";
        }
    }

    function throttle(callback, time) {
        if (throttleTimer) return;
        throttleTimer = true;
        setTimeout(() => {
            callback();
            throttleTimer = false;
        }, time);
    };

    // Sort grouped array by number of members
    function getMode(array) {
        // TODO - this only works in preview versions of Safari currently.
        // return Object.entries(Object.groupBy(array, (element) => element)).sort((a,b) => b[1].length - a[1].length)[0][0];
        let counts = {};
        array.forEach(element => {
            if(counts[element] === undefined) {
                counts[element] = 0;
            }
            counts[element]++;
        });
        return Object.entries(counts).sort((a,b) => b[1]- a[1])[0][0];
    }

    // Create tooltip toggle
    function createTooltipElement(tooltip, field) {
        let holder = createElementHelper("span", {class: "tooltip-explanation-holder"});
        holder.appendChild(createElementHelper("input", {type: "checkbox", id: `${this.companyNumber}_${field}_explanation`}));
        let label = holder.appendChild(createElementHelper("label", {for: `${this.companyNumber}_${field}_explanation`}));
        label.appendChild(createElementHelper("span", {class: "question-mark", innerHTML: "?"}));
        label.appendChild(createElementHelper("span", {class:"tooltip-explanation", innerHTML: tooltip}));
        return holder;
    }

    function toggleHeaderBar(element) {
        const header = element.closest('header');
        header.classList.toggle("minimized");
        localStorage.setItem("headerBarMinimized", header.classList.contains("minimized"));
    }

    function objectsMatch(object1, object2) {
        const objKeys1 = Object.keys(object1);
        const objKeys2 = Object.keys(object2);

        if (objKeys1.length !== objKeys2.length) return false;

        for (var key of objKeys1) {
            const value1 = object1[key];
            const value2 = object2[key];

            const isObjects = isObject(value1) && isObject(value2);

            if ((isObjects && !objectsMatch(sortObjectType(value1), sortObjectType(value2))) ||
            (!isObjects && value1 !== value2)) {
                return false;
            }
        }
        return true;
    }

    function isObject(object) {
        return object != null && typeof object === "object";
    };

    // If object is an array do a simple sort of the values
    function sortObjectType(object) {
        return Array.isArray(object) ? object.sort() : object;
    }

    function addFormValidationError(element, error) {
        const errorElement = coreFunctions.createElementHelper("div", {class: "form-field-error", innerHTML: error});
        element.after(errorElement);
    }

    function removeFormValidationError(element) {
        let validationError;
        if ((validationError = element.nextElementSibling) && validationError.classList.contains("form-field-error")) {
            validationError.remove();
        }
    }

    function refreshFormValidationError(element, error) {
        removeFormValidationError(element);
        if (error.length) {
            addFormValidationError(element, error);
        }
    }

    function refreshFormFieldErrors(form, inputErrors = {}) {
        form.querySelectorAll("[name]").forEach(element => refreshFormValidationError(element, inputErrors[element.name] ?? ""))
    }

    function validateRequiredFormField(element) {
        const value = element.value;
        const fieldname = element.dataset.fieldname;
        let error = (value.length) ? "" : `${fieldname} is a required field`;
        coreFunctions.refreshFormValidationError(element, error);
    }

    function trimFormData(element) {
        element.value = element.value.trim();
    }

    function fileInputHolderDragEnter(event) {
        event.preventDefault();
        event.stopPropagation();
        event.target.classList.add("file-drag-over");
    }

    function fileInputHolderDragLeave(event) {
        event.preventDefault();
        event.stopPropagation();
        event.target.classList.remove("file-drag-over");
    }

    function fileInputHolderDragOver(event) {
        event.preventDefault();
    }

    function fileInputHolderDrop(event, callback) {
        event.preventDefault();
        event.stopPropagation();
        event.target.classList.remove("file-drag-over");
        callback(event.dataTransfer.files[0], event.target);
    }

    function escapeRegExp(string){
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }

    function getUrlHost(url) {
        let urlHost;
        if ((url = formatUrl(url)) && URL.canParse(url)) urlHost = (new URL(url)).hostname;
        if (urlHost) urlHost = urlHost.replace(/^www./, "");
        return urlHost;
    }

    function hideConfirmControls(element) {
        let holder;
        if (holder = element.closest(".confirm-actions-holder")) {
            holder.querySelector("input").checked = false;
        }
    }

    function updateInputCharacterCount(input) {
        const length = input.value ? input.value.toString().length : 0;
        let characterCountHolder;
        if (characterCountHolder = input.parentElement.querySelector(`.character-count-holder`)) {
            characterCountElement = characterCountHolder.querySelector(".character-count");
            characterCountElement.dataset.charcount = length;
            characterCountElement.dataset.charmaxexceeded = (length > Number(characterCountElement.dataset.charmax)) ? 1 : 0;
        }
    }

    function arrayIsEmpty(arr) {
        return !Array.isArray(arr) || (Array.isArray(arr) && !arr.length);
    }

    function userguidingSetup(user) {
        if(window.userGuiding !== undefined) {
            let userDataObject = {
                email: user.user_details.email,
                created_at: user.user_details.sign_up,
                admin: user.admin,
                firstName: user.user_details.first_name,
                lastName: user.user_details.last_name,
                email: user.user_details.email,
                signUpDate: user.user_details.sign_up,
                expiryDate: user.user_details.expiry,
                newUser: (user.new_user.toLowerCase() === "true"),
                trialUser: user.user_details.trial_user
            };
            if(userDataObject.trialUser)
            {
                userDataObject.trialDaysLeft = (7 - moment().diff(moment(user.user_details.sign_up), 'days'));
            }
            window.userGuiding.identify(user.user_details.id, userDataObject);
        }
    }

    function disableButton(element, timeout) {
        if (element.nodeName == "BUTTON") {
            element.disabled = true;
        } else {
            const buttonClass = Array.from(element.classList).find(el => (/-button$/).test(el));
            element.classList.add(`${buttonClass}--disabled`);
        }

        if (timeout) {
            setTimeout(() => enableButton(element), timeout);
        }
    }

    function enableButton(element) {
        if (element.nodeName == "BUTTON") {
            element.disabled = false;
        } else {
            const buttonClass = Array.from(element.classList).find(el => (/-button$/).test(el));
            element.classList.remove(`${buttonClass}--disabled`);
        }
    }

    function sortTableButtonOnClick(element) {
        const order = !element.dataset.order ? (element.dataset.data_type == "numeric" ? "desc" : "asc") : (element.dataset.order == "desc" ? "asc" : "desc");
        let activeSortingElement;
        if (activeSortingElement = element.closest("tr").querySelector(".sortable-table-header__button--asc, .sortable-table-header__button--desc")) {
            activeSortingElement.classList.remove("sortable-table-header__button--asc", "sortable-table-header__button--desc");
            delete activeSortingElement.dataset.order;
        }
        element.classList.toggle("sortable-table-header__button--asc", order == "asc");
        element.classList.toggle("sortable-table-header__button--desc", order == "desc");
        element.dataset.order = order;
    }

    return {
        xhrHelper: xhrHelper,
        createElementHelper: createElementHelper,
        checkForDebugMessages: checkForDebugMessages,
        showOverlay: showOverlay,
        hideOverlay: hideOverlay,
        showStatusMessage: showStatusMessage,
        getQueryVariable: getQueryVariable,
        getRandomString: getRandomString,
        subscribeRequest: subscribeRequest,
        capitaliseFirstLetter: capitaliseFirstLetter,
        formatUrl: formatUrl,
        intersect: intersect,
        signout: signout,
        resetPassword: resetPassword,
        clearResetFields: clearResetFields,
        clearElementContent: clearElementContent,
        clearElementChildren: clearElementChildren,
        pluraliseWord: pluraliseWord,
        processFormValidation: processFormValidation,
        clearFormValidationError: clearFormValidationError,
        throttle: throttle,
        getMode: getMode,
        createTooltipElement: createTooltipElement,
        toggleHeaderBar: toggleHeaderBar,
        objectsMatch: objectsMatch,
        removeFormValidationError: removeFormValidationError,
        addFormValidationError: addFormValidationError,
        refreshFormValidationError: refreshFormValidationError,
        validateRequiredFormField: validateRequiredFormField,
        trimFormData: trimFormData,
        fileInputHolderDragEnter: fileInputHolderDragEnter,
        fileInputHolderDragLeave: fileInputHolderDragLeave,
        fileInputHolderDragOver: fileInputHolderDragOver,
        fileInputHolderDrop: fileInputHolderDrop,
        escapeRegExp: escapeRegExp,
        getUrlHost: getUrlHost,
        hideConfirmControls: hideConfirmControls,
        updateInputCharacterCount: updateInputCharacterCount,
        refreshFormFieldErrors: refreshFormFieldErrors,
        isValidUrl: isValidUrl,
        arrayIsEmpty: arrayIsEmpty,
        userguidingSetup: userguidingSetup,
        disableButton: disableButton,
        enableButton: enableButton,
        sortTableButtonOnClick: sortTableButtonOnClick
    }
}();

function updatePageTitle() {
    let title;
    const titleElements = [
        "#folderName", // listsfolder
        "#companyListTitle", // explore, ml_list
        ".companyListTitle",  // ml_list
        "#insightsMainTitle", // analyse, compare
        `h1.data-field[field="CompanyName"] span`, // companypage
        `.directorSummary h1`, // directors
        ".dashboardTitle",
    ];

    titleElements.forEach(selector => {
        if (!title) {
            const element = document.querySelector(selector);
            if (element && element.innerText) {
                title = element.innerText.trim().replace(/\?$/, "");
            }
        }
    });

    if (title) {
        document.title = `${title} | Industry Engine - The Data City`;
    }
}

function requireLogin() {
    const returnPath = window.location.pathname + window.location.search;
    window.location.href = `${urlPath}/?return=${encodeURIComponent(returnPath)}`;
}
